import { featureCollection, type LineString } from '@turf/helpers';
import { useMemo } from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import useMap from '../../hooks/useMap';
import useMapStyleChange from '../../hooks/useMapStyleChange';
import { getLayerBeforeId, polylinesBottomId, polylinesTopId } from '../../utils/layers';

const sourceId = 'empty-polyline-source';

type Props = {};

const EmptyPolylineLayers = ({}: Props) => {
  const map = useMap();
  const data = useMemo(() => featureCollection<LineString>([]), []);
  useMapStyleChange(map);

  return (
    <Source id={sourceId} type="geojson" data={data}>
      <Layer id={polylinesTopId} beforeId={getLayerBeforeId(map, polylinesTopId)} type="symbol" source={sourceId} />
      <Layer id={polylinesBottomId} beforeId={polylinesTopId} type="symbol" source={sourceId} />
    </Source>
  );
};

export default EmptyPolylineLayers;
